'use client';
const IDENT = 'Link';
const defaultProps = {
    underline: 'none',
    weight: 'regular',
    transitionDuration: 200,
    color: 'info'
};

export { IDENT, defaultProps };
//# sourceMappingURL=Link.contract.js.map
